import { clsx, type ClassValue } from 'clsx'

/**
 * Склейка классов с отбрасыванием пустых значений.
 *
 * Обычно рядом ставят twMerge, чтобы конфликтующие утилиты Tailwind
 * разрешались по последней. Здесь его нет намеренно: компоненты ниже
 * не принимают произвольные утилиты, перекрывающие их собственные, —
 * вариант выбирается пропсом. Разрешать конфликты нечему, а лишняя
 * зависимость в каждом рендере стоит времени.
 */
export function cn(...values: ClassValue[]): string {
  return clsx(values)
}
